import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import './SearchCard.scss';

const SearchCard = ({
  searchBy,
  searchInput,
  errorMessage,
  isSearchEnabled,
  onSearchByChange,
  onSearchInputChange,
  onSearch,
  getPlaceholder
}) => {
  return (
    <Card className='search-card' data-testid='search-card'>
      <CardContent>
        <Box className='search-form'>
          <Typography variant='body1' className='search-label'>
            Search by:
          </Typography>

          <FormControl className='search-select'>
            <InputLabel className='search-select-label'>
              Select an option
            </InputLabel>
            <Select
              value={searchBy}
              onChange={onSearchByChange}
              label='Select an option'
              className='search-select-input'
              data-testid='select-container'>
              <MenuItem value='phone'>Phone Number</MenuItem>
              <MenuItem value='sapid'>SAP ID</MenuItem>
            </Select>
          </FormControl>

          <TextField
            value={searchInput}
            onChange={onSearchInputChange}
            placeholder={getPlaceholder()}
            className='search-input'
          />

          <Button
            variant='contained'
            onClick={onSearch}
            disabled={!isSearchEnabled}
            className='search-button'>
            SEARCH
          </Button>
        </Box>

        {errorMessage && (
          <Alert severity='error' className='error-message'>
            {errorMessage}
          </Alert>
        )}
      </CardContent>
    </Card>
  );
};

SearchCard.propTypes = {
  searchBy: PropTypes.string.isRequired,
  searchInput: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  isSearchEnabled: PropTypes.bool.isRequired,
  onSearchByChange: PropTypes.func.isRequired,
  onSearchInputChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  getPlaceholder: PropTypes.func.isRequired
};

export default React.memo(SearchCard);
